;
// Чтобы передавать по ссылке оно должно быть объектом
let hasLegacyData = { result: false };

if (isBx24Context) {
    BX24.callMethod(
        'entity.get',
        { ENTITY: 'struct' },
        function (result) {
            if (result.error()) {
                hasLegacyData.result = false;
            } else {
                AppUtils.showServiceMessage(result.data());
                hasLegacyData.result = true;
            }
        }
    );
}

function pingStatuses() {
    // В Strict-mode простая проверка на undefined не работает
    if (!window.hasOwnProperty('bx24ImportLegacyBlade')) {
        return false;
    }
    let flags = bx24ImportLegacyBlade.pingStatusesFlags;
    let currentStatus = bx24ImportLegacyBlade.currentStatus;
    let statusUrl = bx24ImportLegacyBlade.statusUrl;

    if (!flags[currentStatus]) {
        // Аксиоса тут нет, но есть JQ
        $.get(statusUrl, null, (response) => {
            if (flags[response]) {
                location.reload();
            } else {
                setTimeout(pingStatuses, 3000);
            }
        });
    }
    return false;
}

pingStatuses();

document.querySelectorAll('.legacy-error').forEach(function(item) {
    item.addEventListener('click', function(e) {
        e.preventDefault();
        let deleteBaseUrl = this.dataset.href;

        $.get(deleteBaseUrl, null, (response) => {
            BX24.callMethod('app.option.set', {legacy:true}, () => {
                BX24.reloadWindow();
            });
        });
    })
});

/*
 * Исследование показало, что если просто записать
 * 'document.querySelector('.legacy-ok').addEventListener('click', function(e) {',
 * то на страницах, где '.legacy-ok' отсуствует, будет ошибка
 * 'Cannot read property 'addEventListener' of null'
 */
document.querySelectorAll('.legacy-not-error').forEach(function(item) {
    item.addEventListener('click', function(e) {
        location = this.dataset.href;
    })
});

module.exports.hasLegacyData = hasLegacyData;
